import React, { useState } from "react";
// import PropTypes from "prop-types";
import { Button, Modal } from "semantic-ui-react";
import { ModalHeader, StyledModal } from "../common/StyledComponents";

const SuccessNotifyModal = (props) => {
  const [open, setOpen] = useState(true);
  let message = "";
  if (props.flow === "DELETE_USER") {
    message = "The user has been deleted.";
  } else if (props.flow === "NEW_USER") {
    message = "The user has been created.";
  } else if (props.flow === "EDIT_USER") {
    message = "The user has been updated.";
  } else if (props.flow === "RESET_USER_PASSWORD") {
    message = 'Password Reset Successful'
  }
  const closeModal = () => {
    setOpen(false);
    props.closeModal();
  };

  return (
    <StyledModal
      onClose={() => closeModal()}
      onOpen={() => setOpen(true)}
      open={open}
      size="mini"
    >
      <ModalHeader regular>Success</ModalHeader>
      <Modal.Content>
        <p>{message}</p>
      </Modal.Content>
      <Modal.Actions>
        <Button primary onClick={() => closeModal()}>
          Ok
        </Button>
      </Modal.Actions>
    </StyledModal>
  );
};

SuccessNotifyModal.propTypes = {};

SuccessNotifyModal.defaultProps = {};

export default SuccessNotifyModal;
